<template>
  <main-layout>

    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-50"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">新規登録</label>
        <sp-smart-button @click="backUsageDetail" slot="cancel">
            {{ $t("button.UsageGuideSetting.backUsageGuide") }}
        </sp-smart-button>

        <narrow-down @click="saveUsageGuide" slot="create" :disabled="disabled">
          {{ $t("button.UsageGuideSetting.saveUsageGuide") }}
        </narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">
        <div>
            <el-form
                label-position="left"
                :rules="rules"
                :model="query"
                class="submit-form"
                label-width="204px"
                ref="query"
                >
                <el-row class="height-44">
                  <el-form-item
                    :label="$t('label.UsageGuideAdd.Type')"
                    prop="type"
                    size="small"
                    class="asterisk line-height-55">
                    <div style="opacity: 0.8;pointer-events: none;">
                      <div v-if="(this.usageGuideFlag === '04' || this.usageGuideFlag === '01') && outlookFlg">
                        <el-radio  v-model="query.type" label="04">Outlook施設</el-radio>
                      </div>
                      <div v-if="(this.usageGuideFlag === '03' || this.usageGuideFlag === '01') && !outlookFlg">
                        <el-radio disabled v-model="query.type" label="03">施設</el-radio>
                      </div>
                      <div v-if="this.usageGuideFlag === '02' || this.usageGuideFlag === '01' && !outlookFlg">
                        <el-radio style="margin-top: 10px" disabled v-model="query.type" label="01">指定席</el-radio>
                      </div>
                      <div>
                        <el-radio style="margin-top: 10px" disabled v-model="query.type" label="02">備品</el-radio>
                      </div>
                    </div>
                  </el-form-item>

                  <el-form-item
                    :label="$t('label.UsageGuideAdd.Name')"
                    prop="name"
                    size="small"
                    class="asterisk line-height-55">
                    <el-input
                      class="lang-width-input"
                      size="small"
                      v-model="query.name"
                      maxlength="8"
                    />
                  </el-form-item>



                  <el-form-item
                    v-if="query.type == '01' || query.type == '03' || query.type == '04'"
                    :label="$t('label.UsageGuideAdd.Color')"
                    prop="color"
                    size="small"
                    class="asterisk line-height-55">
                    <div class ="color">
                        <div class="color1 radio-button-style" @click="selectColor(0)">
                          <img v-show="color == 0" class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                        <div  class="color2 radio-button-style" @click="selectColor(1)">
                          <img v-show="color == 1" class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                        <div  class="color3 radio-button-style" @click="selectColor(2)">
                          <img v-show="color == 2" class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                        <div  class="color4 radio-button-style" @click="selectColor(3)">
                          <img v-show="color == 3" class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                        <div class="color5 radio-button-style" @click="selectColor(4)">
                          <img v-show="color == 4"  class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                    </div>
                  </el-form-item>
                  <el-form-item
                    v-else
                    :label="$t('label.UsageGuideAdd.Img')"
                    prop="portrait"
                    size="small"
                    class="asterisk line-height-55">
                    <upload-image
                        :src ="$GetImageUrl(query.portrait.url)"
                        @deleteSrc="deleteSrc($event)"
                        @eventImage="changeMapImage($event)"
                        @deleteImage="deleteImg($event)">
                    </upload-image>
                  </el-form-item>

                </el-row>
            </el-form>

            <el-dialog-prompt
                :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
                :msgParam="msgParam"
                @on-isPassParam="isPassParam">
            </el-dialog-prompt>

            <loading-dialog :dialogVisible="showLoading" />
        </div>
      <loading-dialog :dialogVisible="showPageLoading" />
    </div>
    <!--  メインページ 終了  -->
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import NewDesignLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import Menubar from "@/components/leftmenu/DashBoard";
import headTitle from "@/components/common/head/head";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import errorCodeMsg from "@/utils/error-code-msg"
import SpSmartButton from "@/components/common/sp-smart-button"
import UploadImage from "@/components/common/sp-smart-upload/index"
import statusErrorCodeMsg from "@/utils/status-error-msg"
const colorList = ["#8C251C","#73226C","#291F99","#198022","#758006"]

export default {
  name: "UsageGuideEdit",
  computed: {
    Type() {
    return this.query.Type
  }
  },
  components: {
    UploadImage:UploadImage,
    SpSmartButton:SpSmartButton,
    MainLayout: NewDesignLayout,
    Menubar: Menubar,
    headTitle: headTitle,
    narrowDown,
    elDialogPrompt,
    LoadingDialog
  },
  data() {
    return {
        rules:{
            name:[
                {
                    required: true,
                    trigger:'change',
                    message: this.$t("message.common.validation.required", {
                        field: this.$t("label.UsageGuideAdd.Name"),
                    })
                }
            ],
            portrait:[
                {
                    required: true,
                    trigger:'change',
                    message: this.$t("message.common.validation.required", {
                        field: "画像",
                    })
                }
            ],
        },
        outlookFlg: false,
        disabled:false,
        usageGuideId:null,
        showLoading:false,
        showPageLoading: false,
        centerDialogVisibleIsShow:false,
        msgParam:"該当エリア凡例を作成してもよろしいでしょうか？",
        color:1,
        query:{
            buildId:null,
            color: null,
            exId: null,
            name: null,
            portrait: {id: null, url: null},
            type: null,
            usageGuideId: null,
        },
        portrait: null,
        usageGuideFlag : null,
    };
  },
  watch: {
      Type() {
          this.$refs['query'].clearValidate();
      },
      query:{
        handler: function (val) {
          let disable = false
          if(val.name == null || val.name == ""){
            disable = true
          }
          if(val.type == '01' && val.color == null){
            disable = true
          }
          if(val.type == '02' && (val.portrait.id == null && this.portrait == null)){
            disable = true
          }
          this.disabled = disable;
        },
        deep: true
      },
  },
  methods: {
      backUsageDetail(){
/*         this.$router.push({
            name: "system-UsageGuideDetail"
        }); */
        this.$router.push({
          name: "system-UsageGuideSetting",
          query:{
            usageGuideFlag : this.usageGuideFlag,
            outlookFlg : this.outlookFlg,
          }
        });
      },
      deleteImg(){
        this.query.portrait  = {id: null, url: null},
        this.portrait = null
      },
      deleteSrc(){
        this.query.portrait = {id: null, url: null},
        this.portrait = null
      },
      changeMapImage(data) {
        for(var i = 0; i < data.length; i++){
            this.query.portrait = data[i].raw
            this.portrait = data[i].raw
        }
      },
      selectColor(index){
        this.color = index
        this.query.color = colorList[index]
      },
      saveUsageGuide(){
        this.$refs["query"].validate((valid) => {
            if(valid){
                this.centerDialogVisibleIsShow = true;
            }
        })
      },
      isPassParam(){
        this.showLoading = true
        this.doneSaveUsageGuide();
      },
      search(){
        SystemManageApi.UsageGuideDetail(this.usageGuideId)
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(({data}) => {
            if (!statusErrorCodeMsg(data.statusCode,this)) {
                return;
            }
            this.showPageLoading = false
            this.query = data.body
            this.color = colorList.indexOf(this.query.color)
          })
          .finally(() => {
          });
      },
      doneSaveUsageGuide(){
        SystemManageApi.UpdateUsageGuide({
            Name: this.query.name,
            color: this.query.color,
            Portrait: this.portrait,
            usageGuideId: this.query.usageGuideId
        })
          .catch((error) => {
              this.showLoading = false
            errorCodeMsg(error, this)
          })
          .then(({data}) => {
            this.showLoading = false
            if (!statusErrorCodeMsg(data.statusCode, this, "usageColor")) {
              return;
            }
            this.done();
          })
          .catch((error) => {
            error;
          })
          .finally(() => {
          });
      },
      done() {
        this.$messageIotSuccess(this.$t('message.common.createSuccess',{
            field: '該当エリア凡例'
        }))
        this.backUsageDetail();
      },
  },
  mounted() {
      this.usageGuideId = this.$getPageInfo("system","UsageGuideSetting","M-06-49","ug").usageGuideId
      //this.usageGuideId = this.$getPageInfo("system", "build", "M-06-50", "ugId")
      this.search();
      this.showPageLoading = true
  },
created() {
    this.$authCheck("010903")
    this.usageGuideFlag = this.$route.query.usageGuideFlag;
    this.outlookFlg = this.$route.query.outlookFlg;
    let breadcrumb = [
      {
          path: "/",
          title: "label.router.home",
      },
      {
          path: "/system/setting/various",
          title: "label.router.set",
      },
      {
          path: "",
          title: "label.router.comprehensive",
      },
      {
          path: "/system/buildings/search",
          title: "label.router.building",
      },
      {
        path: "",
        title: "label.router.detailBuilding",
      },
      {
        path: `/system/usageGuideSetting?usageGuideFlag=${encodeURIComponent(this.usageGuideFlag || "")}&outlookFlg=${encodeURIComponent(this.outlookFlg || "")}`,
        title: "label.router.UsageGuideSetting",
      },

      {
          path: "",
          title: "label.router.UsageGuideEdit",
      },
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

  },
};
</script>

<style lang="scss" scoped>
  ::v-deep .el-form-item__label {
        text-align: justify;
    }
::v-deep .asterisk {
  .el-form-item__label::before{
    display: none;
  }
}
::v-deep .asterisk {
  .el-form-item__label::after{
    content: "※";
    color: #E65245;
    margin-right: 4px;
    font-size: 50%;
    vertical-align: 8%;
  }
}
::v-deep .el-form-item {
  margin-bottom: 40px !important;
}
.line-height-44::v-deep {
  .el-form-item__label {
    line-height: 44px !important;
  }
}
::v-deep .el-form-item__content{
    margin-top: 10px;
}
.line-height-55::v-deep {
  .el-form-item__label {
    line-height: 55px !important;
  }
.class-a{
      border: 0px solid !important;
  }
  .color{
      width: 220px;
      margin-top: 5px !important;
  }
  .selected{
    margin-left: 5px;
  }

  .color1{
      color: #ffffff;
      border-radius: 50%;
      border: 0px solid;
      margin-right: 20px;
      width: 26px;
      height: 26px;
      float: left;
      background-color:#8C251C;
  }
  .color2{
          border-radius: 50%;
      color: #ffffff;
      border: 0px solid;
      margin-right: 20px;
      width: 26px;
      height: 26px;
      float: left;
      background-color:#73226C;
  }
  .color3{
          border-radius: 50%;
      color: #ffffff;
      border: 0px solid;
      margin-right: 20px;
      float: left;
      width: 26px;
      height: 26px;
      background-color:#291F99;
  }
  .color4{
          border-radius: 50%;
      color: #ffffff;
      border: 0px solid;
      margin-right: 20px;
      float: left;
      width: 26px;
      height: 26px;
      background-color:#198022;
  }
  .color5{
          border-radius: 50%;
      color: #ffffff;
      border: 0px solid;
      float: left;
      width: 26px;
      height: 26px;
      background-color:#758006;
  }

}
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}

::v-deep .el-radio__label{
  padding-left: 28px;
  font-size:16px
}
::v-deep .el-dialog__body{
  color: #525250;
}

.radio-button-style {
  cursor: pointer;
}

.radio-button-style:hover {
  opacity: 0.8;
}
</style>
